var config = require("app/config");

module.exports = function(url) {
    if (url
        && url.substring(0, 7) !== "http://"
        && url.substring(0, 8) !== "https://"
        && url.substring(0, 10) !== "data:image"
        && url.substring(0, 2) !== "//"
    ) {
        url = config.imageOptimizer.relativeUrlPrefix.replace(/\/$/, "") + "/" + url.replace(/^\/+/, "");
    }

    return url;
};
